import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  text: string;
  type: 'success' | 'error';
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toastMessage = signal<ToastMessage | null>(null);

  show(message: string, type: 'success' | 'error' = 'success'): void {
    this.toastMessage.set({ text: message, type });
    setTimeout(() => {
      this.toastMessage.set(null);
    }, 3000); // Toast verschwindet nach 3 Sekunden
  }

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'error');
  }
}
